export default __webpack_public_path__ + "static/media/svg-2.22d0e2e0.svg";